import { TASK_ATTACHMENT_FILE_ACCEPT_TYPES, TASK_ATTACHMENT_IMG_ACCEPT_TYPES } from 'constants/file-types';

const ACCEPTED_EXTENSIONS = TASK_ATTACHMENT_IMG_ACCEPT_TYPES.replace(/\s/g, '')
  .split(',')
  .map((ext) => ext.toLowerCase());

export const truncateFilename = (filename: string, maxLength: number = 10): string => {
  const lowerFilename = filename.toLowerCase();
  const matchedExt = ACCEPTED_EXTENSIONS.find((ext) => lowerFilename.endsWith(ext));

  if (!matchedExt) {
    return filename;
  }

  const baseName = filename.slice(0, -matchedExt.length);

  if (baseName.length <= maxLength) {
    return baseName + matchedExt;
  }

  return `${baseName.slice(0, maxLength)}...${matchedExt}`;
};

export const parseExtensions = (types: string): string[] =>
  types
    .replace(/\s/g, '')
    .split(',')
    .map((ext) => ext.toLowerCase());

export const IMG_EXTENSIONS = parseExtensions(TASK_ATTACHMENT_IMG_ACCEPT_TYPES);
export const FILE_EXTENSIONS = parseExtensions(TASK_ATTACHMENT_FILE_ACCEPT_TYPES);

export const getExtension = (filename: string): string => `.${filename.split('.').pop()?.toLowerCase()}`;
